import type { AxiosPromise } from 'axios'
import request from '@user-center/utils/request'

// Query auth list by belonger
export function queryPageAuthListByBelonger(
  data: any,
  headers?: any,
): AxiosPromise<unknown> {
  return request({
    url: '/admin/itemSkuShareInventoryAuth/queryPageAuthListByBelonger',
    method: 'post',
    data,
    headers,
  })
}

// 查询会员信息
export function queryCustomerInfoByMemberCodeApi(data: any): AxiosPromise<any> {
  return request({
    url: '/customerInfo/queryCustomerInfoByMemberCodeApi',
    method: 'post',
    data,
  })
}

// 建立授权关系
export function insertShareInventoryAuthByBelonger(data: any): AxiosPromise<any> {
  return request({
    url: '/admin/itemSkuShareInventoryAuth/insertByBelonger',
    method: 'post',
    data,
  })
}

// 查询授权商品列表
export function queryPageListByBelonger(data: any): AxiosPromise<any> {
  return request({
    url: '/admin/itemSkuShareInventoryAuthDetail/queryPageListByBelonger',
    method: 'post',
    data,
  })
}

// 查询可授权商品列表（支持已授权和未授权筛选）
export function queryPageAuthItemListByBelonger(data: any): AxiosPromise<any> {
  return request({
    url: '/admin/itemSkuShareInventoryAuthDetail/queryPageAuthItemListByBelonger',
    method: 'post',
    data,
  })
}
// 批量授权商品
export function batchInsertShareInventoryAuthDetail(data: any): AxiosPromise<any> {
  return request({
    url: '/admin/itemSkuShareInventoryAuthDetail/batchInsert',
    method: 'post',
    data,
  })
}

// 更新授权状态
export function updateShareInventoryAuthStatusByBelonger(data: { id: number, status: number }) {
  return request({
    url: '/admin/itemSkuShareInventoryAuth/updateByBelonger',
    method: 'post',
    data,
  })
}

// 批量更新授权商品可用状态
export function batchUpdateShareInventoryAuthDetailStatus(data: { id: number, status: number }[]): AxiosPromise<any> {
  return request({
    url: '/admin/itemSkuShareInventoryAuthDetail/batchUpdate',
    method: 'post',
    data,
  })
}


export function queryPageListByGrantee(
  data: any,
  headers?: any,
): AxiosPromise<unknown> {
  return request({
    url: '/admin/itemSkuShareInventoryAuth/queryPageListByGrantee',
    method: 'post',
    data,
    headers,
  })
}

export function queryItemSkuListByGrantee(
  data: any,
  headers?: any,
): AxiosPromise<unknown> {
  return request({
    url: '/admin/itemSkuShareInventoryAuthDetail/queryPageListByGrantee',
    method: 'post',
    data,
    headers,
  })
}

export function queryShareInventoryByBelonger(data: any): AxiosPromise<any> {
  return request({
    url: '/admin/itemSkuShareInventoryAuthDetail/queryPageAuthItemListByBelonger',
    method: 'post',
    data,
  })
}

export function queryPageListInventoryByGrantee(
  data: any,
  headers?: any,
): AxiosPromise<unknown> {
  return request({
    url: '/admin/itemShareInventory/queryPageListByGrantee',
    method: 'post',
    data,
    headers,
  })
}

export function queryPageShareInventoryByBelonger(
  data: any,
  headers?: any,
): AxiosPromise<unknown> {
  return request({
    url: '/admin/itemShareInventory/queryPageShareInventoryByBelonger',
    method: 'post',
    data,
    headers,
  })
}

export function queryItemShareInventoryFlowPageInfo(
  data: any,
  headers?: any,
): AxiosPromise<unknown> {
  return request({
    url: '/admin/itemSkuInventory/queryItemShareInventoryFlowPageInfoByCondition',
    method: 'post',
    data,
    headers,
  })
}
